// extracted by mini-css-extract-plugin
export default {"sidebar_item":"sidebarItem_sidebar_item__1RjD1","texto_link":"sidebarItem_texto_link__W41tq","link_ativo":"sidebarItem_link_ativo__PKpe8"};